import React, { useState } from 'react';
import { Button } from '@mui/material';
import './DeleteUser.scss';
import GenericModal from '../generic-modal/GenericModal';

const DeleteUser = ({
  deleteUser,
  isLoading,
}: {
  deleteUser: () => void;
  isLoading: boolean;
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleShowModal = () => {
    setIsOpen(!isOpen);
  };

  const handleConfirm = () => {
    deleteUser();
  };

  return (
    <div className="delete-wrapper">
      <Button
        onClick={handleShowModal}
        className="delete-button"
        data-testid="delete-user"
      >
        Delete user
      </Button>
      <GenericModal
        open={isOpen}
        title="Are you sure?"
        content="Are you sure you want to delete that user?"
        confirmButtonText="Delete"
        cancelButtonText="Cancel"
        handleConfirm={handleConfirm}
        handleCancel={handleShowModal}
        mode="warning"
        isLoading={isLoading}
        loadingButton
        confirmButtonTestId="confirm-delete-user"
      />
    </div>
  );
};

export default DeleteUser;
